import processCSV from './process-csv';
import processJSON from './process-json';
import processXML from './process-xml';

/**
 * Fetches and processes data from a given URL based on the specified type.
 *
 * @param {String} type - The type of the file ('csv', 'json', 'xml').
 * @param {String} url - The URL of the file.
 * @param {Object} [options] - Additional options for processing.
 * @param {Number} [options.headerRow=0] - The row index for the headers in CSV (default is 0).
 * @param {String} [options.separator=','] - The separator used in the CSV file (default is comma).
 * @param {Boolean} [options.hasHeaders=true] - Indicates if the CSV has headers.
 * @return {Promise<Object>} An object containing parsed data.
 */
const getFileData = async ( type, url, options = {} ) => {
	try {
		const response = await fetch( url );
		const data = await response.text();

		switch ( type ) {
			case 'csv':
				return processCSV( data, options.headerRow, options.separator, options.hasHeaders );
			case 'json':
				return processJSON( data );
			case 'xml':
				return processXML( data );
			default:
				throw new Error( 'Unsupported data type' );
		}
	} catch ( error ) {
		console.error( `Error fetching ${type}:`, error );
		return null;
	}
}

export default getFileData;
